import useAxios from '@/compositions/useAxios';

const { fetchData, postData } = useAxios();

export function useUpdatePushTokenApi(payload) {
	return new Promise((resolve, reject) => {
		postData(
			'/v1/push/updatePushToken',
			payload,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}
